<template>
  <v-app>
    <div class="card pl-4 pt-1 pr-3 pb-3">
      <h3 class="partnerHeading p-0 m-0">Partner Status</h3>
      <div class="row p-0 mr-0 mt-3 pl-3">
        <div class="py-4 px-2 m-0 search-button-card">
          <!-- <hr class="hr-class" /> -->
          <w-dropdown-with-search-table
            class="row p-0 m-0 mt-2"
            :items="selectedFieldsArray"
            :searchSource="searchSource"
            :searchPlaceholder="'Search Partner Name / Partner code'"
            @searchAutoCompleEvent="getSearchTerm($event)"
            @getFieldEvent="getFieldsSelected($event)"
            :searchLoading="searchLoading"
          />
          <div class="row p-0 m-0">
            <w-button-input
              @onButtonClick="getSearchedText(searchedText)"
              :buttonStyle="'searchButton'"
              :buttonText="'Submit'"
              :disabled="searchedText == ''"
            />
          </div>
        </div>
        <!-- <div class="col-1 p-0 m-0 ml-n4 mr-n4"></div> -->
        <div class="pt-4 px-2 pb-2 m-0 ml-4 datepicker-status-card">
          <!-- <hr class="hr-class" /> -->
          <div class="m-0 p-0">
            <date-picker
              v-model="selectedDateRange"
              range
              :lang="'en'"
              confirm
              @confirm="getselectedDate($event)"
              :format="'D-MMM-YYYY'"
              :shortcuts="false"
              :not-after="Date.now()"
              :not-before="''"
              :rangeSeparator="'-'"
              class="w-100"
            ></date-picker>
          </div>
          <w-anchor-link class="p-0 m-0 mt-3 w-100" :anchors="anchors" />
        </div>
      </div>
    </div>
    <div class="wo-card card-shadows m-4 mt-4 mr-2">
      <!-- <table class="table table-striped"> -->
      <table class="table celled structured">
        <thead>
          <tr class="table-bg">
            <th class="table-bg" scope="col">SI No</th>
            <th class="table-bg" scope="col">Vendor Code</th>
            <th class="table-bg" scope="col">Description</th>
            <th class="table-bg" scope="col">Bussiness Type</th>
            <th class="table-bg" scope="col">Bussiness Status</th>
            <th class="table-bg" scope="col">Empanelled for</th>
            <th class="table-bg" scope="col">Performance Rating</th>
            <th class="table-bg" scope="col">Vendor Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            :class="getTableColor[index]"
            v-for="(data, index)  in partnerStatusTableData"
            :key="index"
          >
            <td class="table-body-name">{{data.copySlno}}</td>
            <td class="table-body-name">{{data.copyVendorCode}}</td>
            <td class="table-body-name">{{data.copyDescription}}</td>
            <td class="table-body-number">{{data.bussinessType}}</td>
            <td class="table-body-number">{{data.bussinessStatus}}</td>
            <td class="table-body">{{data.empaneledFor}}</td>
            <td class="table-body">{{data.performanceRating}}</td>
            <td class="table-body">
              <span>
                <!-- <button :id="`popoverActions${index}`" class="partner-action-text-button"> -->
                <!-- Action -->
                <img
                  v-if="data.copySlno"
                  @click="openPartnerStatusModal(index)"
                  class="ml-1"
                  src="@/assets/pencil-edit-button.svg"
                />
                <!-- </button> -->
                <!-- <b-popover
                  class="popover-actions"
                  :target="`popoverActions${index}`"
                  triggers="focus"
                  placement="bottomleft"
                >
                  <div class="check-box-container">
                    <span class="m-0 p-0 pl-2">
                      <input
                        type="checkbox"
                        class="p-0 m-0"
                        v-model="activeChecked"
                        @change="getActiveCheckedValue(activeChecked, $event)"
                      />
                    </span>
                    <span class="m-0 p-0 pl-2">Active{{index}}</span>
                  </div>
                  <div class="check-box-container">
                    <span class="m-0 p-0 pl-2">
                      <input
                        type="checkbox"
                        class="p-0 m-0"
                        v-model="inActiveChecked"
                        @change="getInActiveCheckedCheckedValue(inActiveChecked, $event)"
                      />
                    </span>
                    <span class="m-0 p-0 pl-2">Inactive{{index}}</span>
                  </div>
                </b-popover>-->
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <w-partner-status-modal
      :trigger="partnerStatusModal"
      :text="''"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :partnerStatusModalStartIndex="partnerStatusModalStartIndex"
      :partnerStatusModalEndIndex="partnerStatusModalEndIndex"
      @eventClose="closePartnerStatusModal()"
    />
  </v-app>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import multiSelect from "vue-multi-select";
import Modal from "../widgets/ModalWidget";
import textArea from "../widgets/TextArea";
import PartnerStatusModal from "../widgets/partnerStatusModal";
import Datepicker from "../widgets/DatePicker";
import ButtonInput from "../widgets/ButtonInput";
import AnchorWithLink from "../widgets/AnchorWithLink.vue";
import SummaryNavbar from "../components/summary/summaryNavbar";
import EmpanelmentNavbar from "@/components/EmpanelmentNavbar.vue";
import DropdownWithSearchTable from "../widgets/dropDownWithInlineSearch";
import { SummaryServices } from "../services/summaryService";
const SummaryService = new SummaryServices();

export default {
  props: ["answer", "userId"],
  components: {
    multiSelect,
    DatePicker,
    "w-modal": Modal,
    "w-date": Datepicker,
    "w-textArea": textArea,
    "w-button-input": ButtonInput,
    "w-anchor-link": AnchorWithLink,
    "c-summary-navbar": SummaryNavbar,
    "c-empanelment-navbar": EmpanelmentNavbar,
    "w-partner-status-modal": PartnerStatusModal,
    "w-dropdown-with-search-table": DropdownWithSearchTable
  },
  watch: {},
  computed: {},
  data() {
    return {
      getTableColor: [],
      selectedDateRange: [],
      partnerStatusModal: false,
      partnerStatusModalStartIndex: 0,
      partnerStatusModalEndIndex: 0,
      activeChecked: false,
      inActiveChecked: false,
      searchedText: "",
      selectedFieldsArray: [],
      searchSource: [],
      searchLoading: false,
      partnerStatusTableData: [],
      anchors: [
        {
          anchorText: "Total",
          anchorvalue: 0,
          isAnchorDot: false,
          anchorDotClass: ""
        },
        {
          anchorText: "Accepted",
          anchorvalue: 0,
          isAnchorDot: true,
          anchorDotClass: "dot dot-green"
        },
        {
          anchorText: "Rejected",
          anchorvalue: 0,
          isAnchorDot: true,
          anchorDotClass: "dot dot-red"
        },
        {
          anchorText: "Pending",
          anchorvalue: 0,
          isAnchorDot: true,
          anchorDotClass: "dot dot-yellow"
        }
      ]
    };
  },
  created() {
    this.sortDistinctArrayData();
    this.getDefauldValue();
  },
  methods: {
    getActiveCheckedValue(checked, e) {
      console.log(e);
      console.log(checked);
      this.activeChecked = checked;
    },
    getInActiveCheckedCheckedValue(checked, e) {
      console.log(e);
      console.log(checked);
      this.inActiveChecked = checked;
    },
    getSearchTerm(event) {
      if (event.length > 2) {
        this.searchLoading = true;
        console.log(event);
      } else {
        this.searchLoading = false;
        this.searchSource = [];
      }
    },
    getFieldsSelected(event) {
      if (event != "") {
        console.log(event);
        this.getSearchedText(event);
      }
    },
    getSearchedText(event) {
      this.searchedText = event;
    },
    getselectedDate(event) {
      console.log("DateFrom", event[0].toLocaleDateString());
      console.log("DateTo", event[1].toLocaleDateString());
    },
    getDefauldValue() {
      var date = new Date();
      this.selectedDateRange[0] = date.setDate(date.getDate() - 30);
      this.selectedDateRange[1] = new Date();
    },
    openPartnerStatusModal(i) {
      this.partnerStatusModalStartIndex = i;
      this.partnerStatusModalEndIndex = i;
      for (
        let j = this.partnerStatusModalStartIndex;
        j < this.partnerStatusTableData.length;
        j++
      ) {
        if (
          this.getTableColor[this.partnerStatusModalStartIndex] ==
          this.getTableColor[j + 1]
        ) {
          this.partnerStatusModalEndIndex = this.partnerStatusModalEndIndex + 1;
        } else {
          break;
        }
      }
      this.partnerStatusModal = true;
    },
    closePartnerStatusModal() {
      this.partnerStatusModal = false;
    },
    sortDistinctArrayData() {
      let tempArray = [
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO1",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO1",
          description: "Birla Cements",
          bussinessType: "Manufacturer",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO1",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO1",
          description: "Birla Cements",
          bussinessType: "Manufacturer",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO1",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO1",
          description: "Birla Cements",
          bussinessType: "Services",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO1",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO1",
          description: "Birla Cements",
          bussinessType: "Services",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO2",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO2",
          description: "Birla Cements",
          bussinessType: "Manufacturer",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO2",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO2",
          description: "Birla Cements",
          bussinessType: "Manufacturer",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO2",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO2",
          description: "Birla Cements",
          bussinessType: "Services",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO2",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO2",
          description: "Birla Cements",
          bussinessType: "Services",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO3",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO3",
          description: "Birla Cements",
          bussinessType: "Manufacturer",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO3",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO3",
          description: "Birla Cements",
          bussinessType: "Manufacturer",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO3",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO3",
          description: "Birla Cements",
          bussinessType: "Services",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        },
        {
          slno: "01",
          // copySlno: "01",
          // copyVendorCode: "SMNOOO3",
          // copyDescription: "Birla Cements",
          vendorCode: "SMNOOO3",
          description: "Birla Cements",
          bussinessType: "Services",
          bussinessStatus: "Onboarded",
          empaneledFor: "Concrete, Electrical Supplier….",
          performanceRating: "STAR 3/5"
        }
      ];
      this.partnerStatusTableData = [];
      var checkVendorCode = "";
      for (let i = 0; i < tempArray.length; i++) {
        if (checkVendorCode != "") {
          if (checkVendorCode == tempArray[i].vendorCode) {
            if (this.getTableColor[i - 1] == "white-bg") {
              this.getTableColor[i] = "white-bg";
            } else {
              this.getTableColor[i] = "color-bg";
            }
            tempArray[i].copySlno = "";
            tempArray[i].copyVendorCode = "";
            tempArray[i].copyDescription = "";
            this.partnerStatusTableData.push(tempArray[i]);
          } else {
            if (this.getTableColor[i - 1] == "white-bg") {
              this.getTableColor[i] = "color-bg";
            } else {
              this.getTableColor[i] = "white-bg";
            }
            tempArray[i].copySlno = tempArray[i].slno;
            tempArray[i].copyVendorCode = tempArray[i].vendorCode;
            tempArray[i].copyDescription = tempArray[i].description;
            this.partnerStatusTableData.push(tempArray[i]);
            checkVendorCode = tempArray[i].copyVendorCode;
          }
        } else {
          this.getTableColor[i] = "color-bg";
          tempArray[i].copySlno = tempArray[i].slno;
          tempArray[i].copyVendorCode = tempArray[i].vendorCode;
          tempArray[i].copyDescription = tempArray[i].description;
          checkVendorCode = tempArray[i].vendorCode;
          this.partnerStatusTableData.push(tempArray[i]);
        }
      }
      var checkBussinessType = "";
      for (let i = 0; i < this.partnerStatusTableData.length; i++) {
        if (checkBussinessType != "") {
          if (
            checkBussinessType == this.partnerStatusTableData[i].bussinessType
          ) {
            this.partnerStatusTableData[i].bussinessType = "";
          } else {
            checkBussinessType = this.partnerStatusTableData[i].bussinessType;
          }
        } else {
          checkBussinessType = this.partnerStatusTableData[i].bussinessType;
        }
      }
    }
  }
};
</script>

<style>
.color-bg {
  background: #ededed;
}
.white-bg {
  background: #ffffff;
}
.check-box-container {
  display: block;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14.5px;
}
.mx-input {
  border: none !important;
  border-bottom: 1px solid black !important;
  box-shadow: none !important;
  background: none !important;
  border-radius: 0 !important;
  padding-left: 0px !important;
}
.mx-input-wrapper > .mx-input:focus {
  border: none !important;
  border-bottom: 1px solid black !important;
}
.popover-body {
  min-width: 100px !important;
  min-height: 28px !important;
}
.hr-class {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}
.search-bar {
  width: 30% !important;
}
.search-bar .input-group-prepend .input-group-text {
  height: 40px;
  border-radius: 0;
  border: 1px solid #b9b9b9;
  background: transparent !important;
  cursor: pointer;
}

.search-bar .form-control {
  height: 40px;
  border-radius: 0;
  border: 1px solid #b9b9b9;
  font-size: 16px;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
.partnerHeading {
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
}

.card {
  box-shadow: 0 1px 3px 0 rgba(63, 63, 68, 0.15) !important;
  background-color: #ffffff !important;
}
.table-bg {
  font-size: 14px;
  font-weight: 600;
  font-family: "Lato", sans-serif;
  color: #ffffff !important;
  background-color: #6192b1 !important;
  border-color: #6192b1 !important;
  text-align: center;
  margin-right: 5% !important;
}
.table-body {
  padding: 1%;
  font-size: 14px;
  /* text-align: left; */
  font-family: "Lato", sans-serif;
}
.table-body-number {
  padding-right: 3%;
  font-size: 14px;
  text-align: right;
  font-family: "Lato", sans-serif;
}
.table-body-name {
  font-size: 14px;
  text-align: left;
  font-family: "Lato", sans-serif;
}
.table-body-cell {
  padding: 1%;
  font-size: 14px;
  text-align: left;
  background-color: #edf6fd;
  font-family: "Lato", sans-serif;
}
.partner-action-text-button {
  cursor: pointer;
}
.partner-action-text-button:focus {
  outline: none;
}
.datepicker-status-card {
  width: 530px !important;
  border: solid 1px #cbd5dd;
  /* background-color: #f8f8f8; */
}
.search-button-card {
  width: 500px !important;
  border: solid 1px #cbd5dd;
  /* background-color: #f8f8f8; */
}
@media (max-width: 1350px) {
  .search-button-card {
    width: 370px !important;
  }
  .datepicker-status-card {
    width: 400px !important;
  }
}
@media (max-width: 1090px) {
  .search-button-card {
    width: 350px !important;
  }
  .datepicker-status-card {
    width: 360px !important;
  }
}
</style>